'use client'

import { createContext, useContext, ReactNode, useMemo } from 'react'
import { LOCAL, ServerEnv } from '@/lib/server-env'

export type ServerEnvInfo = {
  serverEnv: ServerEnv
  envSwitchUrl: string
}

const ServerEnvironmentContext = createContext<ServerEnvInfo>({
  serverEnv: LOCAL,
  envSwitchUrl: '',
})

export function useServerEnvInfo() {
  return useContext(ServerEnvironmentContext)
}

export type ServerEnvironmentProviderProps = {
  serverEnv: ServerEnv
  envSwitchUrl: string
  children?: ReactNode
}

export function ServerEnvironmentProvider({
  serverEnv,
  envSwitchUrl,
  children,
}: ServerEnvironmentProviderProps) {
  return (
    <ServerEnvironmentContext.Provider
      value={useMemo(() => ({ serverEnv, envSwitchUrl }), [serverEnv, envSwitchUrl])}
    >
      {children}
    </ServerEnvironmentContext.Provider>
  )
}
